import Alpine from '../../builder/node_modules/alpinejs';
import AlpineCurrencySwitcher from './components/currency-switcher';
import AlpineSorting from './components/sorting';
import AlpineBookingCalendar from './components/booking-calendar';

document.addEventListener('DOMContentLoaded', function () {
  window.Alpine = Alpine;
  
  AlpineCurrencySwitcher();
  AlpineSorting();
  AlpineBookingCalendar();

  Alpine.start();
});